import { Component } from '@grafikr/components';

export default Component((node) => {
  const triggers = node.querySelectorAll<HTMLElement>('[aria-controls]');
  const submenus = node.querySelectorAll<HTMLElement>('[aria-selected]');

  const triggerHandler = (event: MouseEvent) => {
    if (!(event.currentTarget instanceof HTMLElement)) {
      return;
    }

    const relatedMenu = node.querySelector<HTMLElement>(
      `#${event.currentTarget.getAttribute('aria-controls')}`,
    );

    if (!relatedMenu) {
      return;
    }

    event.preventDefault();

    triggers.forEach((trigger) => {
      trigger.ariaExpanded = 'false';
    });

    submenus.forEach((menu) => {
      menu.ariaSelected = 'false';
      menu.hidden = true;
    });

    event.currentTarget.ariaExpanded = 'true';

    relatedMenu.ariaSelected = 'true';
    relatedMenu.hidden = false;
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', triggerHandler);
  });
});
